import * as ActionType from "./logistics.type";

const initialState = {
  orders: [],
  totalOrders: 0,
  sentOrders: [],
  totalSentOrders: 0,
  loading: false,
  lastSentResponse: null,
  trackingData: null,
};

export const logisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_LOGISTICS_ORDERS:
      return {
        ...state,
        orders: action.payload.orders,
        totalOrders: action.payload.total,
      };

    case ActionType.GET_SENT_LOGISTICS_ORDERS:
      return {
        ...state,
        sentOrders: action.payload.orders,
        totalSentOrders: action.payload.total,
      };

    case ActionType.SEND_TO_LOGISTICS:
      return {
        ...state,
        lastSentResponse: action.payload.response,
      };

    case ActionType.UPDATE_LOGISTICS_ORDER:
      // Remove the order from the list after sending to logistics
      return {
        ...state,
        orders: state.orders.filter((order) => order._id !== action.payload),
        totalOrders: state.totalOrders > 0 ? state.totalOrders - 1 : 0,
      };

    case ActionType.SET_LOGISTICS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case ActionType.SET_TRACKING_DATA:
      return {
        ...state,
        trackingData: action.payload,
      };

    case ActionType.CLEAR_TRACKING_DATA:
      return {
        ...state,
        trackingData: null,
      };

    case ActionType.DELETE_LOGISTICS_ORDER:
      // Remove the order from the appropriate list based on tab
      if (action.payload.tab === "confirmed") {
        return {
          ...state,
          orders: state.orders.filter((order) => order._id !== action.payload.orderId),
          totalOrders: state.totalOrders > 0 ? state.totalOrders - 1 : 0,
        };
      } else {
        return {
          ...state,
          sentOrders: state.sentOrders.filter((order) => order._id !== action.payload.orderId),
          totalSentOrders: state.totalSentOrders > 0 ? state.totalSentOrders - 1 : 0,
        };
      }

    default:
      return state;
  }
};
